import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = "La collezione completa in 6 volumi + 5 bonus per insegnare l'industria mineraria e le risorse minerali in modo chiaro, visivo e pronto per la classe.";
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'it';
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-slate-950 font-sans text-slate-300 antialiased" data-id="element-0" data-mp="nvasltl5rjh6">
      <MetaPixel data-id="element-1" data-mp="swqbbezv5dwe" />
      <main data-id="element-2" data-mp="36hvn4muyo06">
        <Hero data-id="element-3" data-mp="35ypel6klo1z" />
        <LookInsideCarousel data-id="element-4" data-mp="35ovwnmbgyrj" />
        <ProblemSection data-id="element-5" data-mp="34nabp7octvk" />
        <SystemSection data-id="element-6" data-mp="38b6kw4i7udz" />
        <ModulesSection data-id="element-7" data-mp="3udaw269tuj3n" />
        <BonusSection data-id="element-8" data-mp="3ubzt28o7hfdl" />
        <UrgencySection data-id="element-9" data-mp="3ucjdbw1bwfus" />
        <PricingSection data-id="element-10" data-mp="d4nwrk0ubq3z" />
        <GuaranteeSection data-id="element-11" data-mp="d57d4waue6fw" />
        <FAQ data-id="element-12" data-mp="d3cr1enu48a8" />
        <ClosingSection data-id="element-13" data-mp="d3wbp34vdary" />
        <SummaryTable data-id="element-14" data-mp="85l3sxy4xacd" />
        <FinalCta data-id="element-15" data-mp="851mnjgb6pze" />
      </main>
      <Footer data-id="element-16" data-mp="86w3alkjrvxo" />
      <PurchaseNotification data-id="element-17" data-mp="86cld4uwd7jn" />
    </div>;
}